import { ButtonLink, Carousel } from "@scandotcom/react";
import * as React from "react";
import { i18n } from "../i18n";

type CarouselService = {
  name: string;
  body: string;
  image: string;
  price: number;
  url: string;
};

interface Props {
  services: CarouselService[];
}

export const ServiceCarousel = ({ services }: Props) => {
  return (
    <div className="container">
      <Carousel
        headingContent={(buttons) => (
          <div className="mb-6 flex gap-4">
            <h2 className="display-3xl">Other Scanning Services</h2> {buttons}
          </div>
        )}
        items={services.map((s) => (
          <div
            key={s.name}
            className="bg-cream-200 flex h-full flex-col overflow-hidden rounded-2xl"
          >
            <div className="h-48">
              <img
                src={s.image}
                alt={s.name}
                className="h-full w-full object-cover"
              />
            </div>
            <div className="p-6">
              <h3 className="font-maison-extended mb-2 text-lg font-bold text-neutral-900">
                {s.name}
              </h3>
              <p className="text-sm text-neutral-600">{s.body}</p>
            </div>
            <div className="mt-auto flex justify-between gap-6 px-6 pb-6">
              <dl>
                <dd className="text-sm text-neutral-500">Price from</dd>
                <dt className="font-maison-extended text-xl font-bold">
                  £{s.price}
                </dt>
              </dl>
              <div>
                <ButtonLink href={s.url} kind="primary" className="block">
                  Learn more
                </ButtonLink>
              </div>
            </div>
          </div>
        ))}
      ></Carousel>
    </div>
  );
};
